module.exports = __webpack_public_path__ + "static/media/cash-plus.d0a74dfd.svg";